import localesEn from '@/views/Auth/i18n/localeEn';

const translations = {
  en: {
    ...localesEn.en,
    SEO_TITLE: 'Sign in',
    SEO_DESCRIPTION: 'Sign in and learn new skills today.',
    FORM_TITLE: 'Unlock your talent',
    FORM_SUBTITLE: 'To continue, set up a password for your account.',
    INPUT_EMAIL_LABEL: 'Email',
    INPUT_EMAIL_HINT: 'Enter your email',
    INPUT_USERNAME_LABEL: 'Username',
    INPUT_USERNAME_HINT: 'Enter your username',
    INPUT_DNI_LABEL: 'DNI',
    INPUT_DNI_HINT: 'Enter your DNI',
    INPUT_PASSWORD_LABEL: 'Password',
    INPUT_PASSWORD_HINT: 'Enter password',
    PASSWORD_CANNOT_CONTAIN_SPACES: 'Password cannot contain spaces',
    FORGOT_PASSWORD: 'Forgot your password?',
    BUTTON_SUBMIT_LABEL: 'Sign in',
    BUTTON_SUBMIT_EMAIL: 'Confirm email',
    SOCIAL_LABEL: 'Sign in with:',
    EMAIL_FORM_DESCRIPTION:
      'Assign an email to your account to complete the setup',
    CHANGE_PASSWORD_ERROR_MESSAGE:
      'An error occurred while changing the password. Please try again.',
    LEARNING_SESSION_QUERY_ERROR:
      'An error occurred while getting the learning session. Please try again.',
    LEARNING_SESSION_NOT_FOUND:
      'No learning session found. Please contact your administrator to ensure your account is properly configured.',
    RETRY: 'Retry',
    RELOAD_PAGE: 'Reload page',
    CHANGE_PASSWORD_FORM_TITLE: 'Change password',
    CHANGE_PASSWORD_FORM_DESCRIPTION:
      'Your administrator has requested that you update your password to meet the security requirements of the organization.',
    CHANGE_PASSWORD_FORM_INPUT_PASSWORD_LABEL: 'Create password',
    CHANGE_PASSWORD_FORM_INPUT_PASSWORD_HINT: 'Enter your password',
    CHANGE_PASSWORD_FORM_INPUT_CONFIRM_PASSWORD_LABEL: 'Confirm password',
    CHANGE_PASSWORD_FORM_INPUT_CONFIRM_PASSWORD_HINT: 'Confirm password',
    CHANGE_PASSWORD_FORM_BUTTON_SUBMIT_LABEL: 'Confirm password',
    CHANGE_PASSWORD_FORM_BUTTON_SUBMIT_LABEL_LOADING: 'Changing password...',
    PASSWORD_DOES_NOT_MATCH: 'Passwords do not match',
    CHANGE_PASSWORD_FORM_REQUIRED: 'This field is required',
    CHANGE_PASSWORD_FORM_MIN_LENGTH:
      'Your password must be at least 6 characters',
    CHANGE_PASSWORD_FORM_MAX_LENGTH:
      'Your password cannot be longer than 50 characters',
    CHANGE_PASSWORD_STRENGTH_VERY_WEAK: 'Very weak',
    CHANGE_PASSWORD_STRENGTH_WEAK: 'Weak',
    CHANGE_PASSWORD_STRENGTH_MEDIUM: 'Medium',
    CHANGE_PASSWORD_STRENGTH_STRONG: 'Strong',
    CHANGE_PASSWORD_STRENGTH_REQUIREMENTS_TITLE: 'Required requirements',
    CHANGE_PASSWORD_STRENGTH_REQUIREMENT_TITLE_SINGULAR: 'Required requirement',
    CHANGE_PASSWORD_STRENGTH_RETRY: 'Retry',
    CHANGE_PASSWORD_UNCHANGED_ERROR_TITLE: 'Password must be different',
    CHANGE_PASSWORD_UNCHANGED_ERROR_DESCRIPTION:
      'Enter a new password that you have not used before.',

    BUTTON_LABEL_LOGIN_WITH_GOOGLE_SIGN_IN: 'Sign in with Google',
    BUTTON_LABEL_LOGIN_WITH_MICROSOFT_SIGN_IN: 'Sign in with Microsoft',
    BUTTON_LABEL_LOGIN_WITH_MICROSOFT_SECURE_AUTH: 'Sign in with SecureAuth',
    BUTTON_LABEL_LOGIN_WITH_OPENAGORA: 'Sign in with Openagora',
  },
};

export default translations;
